import { createFileRoute } from '@tanstack/react-router';
import { AppLayout } from '@/components/layout/AppLayout';
// Write flow — reached only via the entry-cards on /migrations/new. The Sidebar/Header
// don't link here directly so menu-based filtering can't protect this page; a Viewer
// who types the URL would otherwise see the wizard and only hit a 403 on submit.
import { OperatorGuard } from '@/components/guards/OperatorGuard';
import { MassMigrationWizard } from '@/features/mass-migration/wizard/MassMigrationWizard';

export const Route = createFileRoute('/migrations/mass')({
  component: MassMigrationWizardPage,
});

function MassMigrationWizardPage() {
  return (
    <OperatorGuard>
      <AppLayout>
        <MassMigrationWizard />
      </AppLayout>
    </OperatorGuard>
  );
}
